
export default {
  space: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44],
  fontSizes: [12, 14, 16, 20, 24, 32],
  breakpoints: ['1280px', '32em', '48em'],
  colors: {
    primary: '#00c2c2',
    gray: 'gray',
  },
};
